import styled from "styled-components";
import { motion } from "framer-motion";

export const Preloader_Container = styled(motion.div)`
	position: relative;

	z-index: 1;
	width: 220px;
	min-height: 160px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	border-radius: 20px;
	//background: rgba(20, 20, 20, 0.3);
	//backdrop-filter: blur(16px);
	//box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
`;

export const Preloader_Spinner = styled(motion.div)`
	width: 36px;
	height: 36px;
	border-radius: 50%;
	border: 3px solid rgba(255, 255, 255, 0.15);
	border-top-color: white;
`;

export const Preloader_Text = styled(motion.div)`
	font-size: 14px;
	color: rgba(255, 255, 255, 0.8);
`;
